import { Box, Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import ModalLoading from '../../components/Loader/ModalLoader';
import NavigationScroll from '../../components/Navigation/NavigationScroll';
import { safeJsonParse } from '../../helper/utils/safeJsonParse';
import { doCheckEmail } from '../../redux/waiver/waiver.actions';
import DashboardSidebar from './components/DashboardSidebar';
import useHistoryTransactions from './hooks/useHistoryTransactions';

export default function DashboardLayout() {
    const dispatch = useDispatch();
    const waiver = safeJsonParse(localStorage.getItem('waiver'), {})?.data || {};

    const { loadingWaiver } = useSelector((state) => state.waiver);
    const { handleGetAllHistoryTransactions } = useHistoryTransactions();

    useEffect(() => {
        dispatch(doCheckEmail({ email: waiver.email || '' }, null, null));
        handleGetAllHistoryTransactions();
    }, []);

    return (
        <Flex direction={{ base: 'column', md: 'row' }} h='100vh' bg='gray.100' w='full' overflow='hidden'>
            {/* Sidebar */}
            <DashboardSidebar />

            {/* Main Content */}
            <Box flex={1} p={{ base: 3, sm: 4, md: 6, lg: 8 }} minH='full' overflowY='scroll' maxW='100%'>
                <NavigationScroll>
                    <Outlet />
                </NavigationScroll>
            </Box>

            <ModalLoading loading={loadingWaiver} />
        </Flex>
    );
}
